"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Platform;
(function (Platform) {
    Platform[Platform["WEB"] = 1] = "WEB";
    Platform[Platform["ANDROID"] = 2] = "ANDROID";
    Platform[Platform["IOS"] = 3] = "IOS";
    Platform[Platform["MOBILE"] = 4] = "MOBILE";
})(Platform = exports.Platform || (exports.Platform = {}));
var EZPlatform;
(function (EZPlatform) {
    EZPlatform["EZBUY_PC"] = "EZBUY_PC";
    EZPlatform["EZBUY_M"] = "EZBUY_M";
    EZPlatform["MC_EZBUY_PC"] = "MC_EZBUY_PC";
    EZPlatform["MC_EZBUY_M"] = "MC_EZBUY_M";
})(EZPlatform = exports.EZPlatform || (exports.EZPlatform = {}));
exports.PLATFORM = {
    WEB: Platform.WEB,
    ANDROID: Platform.ANDROID,
    IOS: Platform.IOS,
    MOBILE: Platform.MOBILE
};
exports.CHANNELS = {
    default: 0,
    top: 1,
    search: 2,
    category: 3,
    navigation: 4,
    carousel: 5,
    side: 6,
    hot: 7,
    flashdeal: 8,
    saleszone: 9,
    floor: 10,
    magicbanner: 13,
    banner: 11,
    countdown: 16,
    tabpro: 14,
    bannerpro: 17,
    pro4: 18,
    bannerpro4: 19,
    tabbannerpro: 15,
    banner4: 20,
    text: 12,
    banner2: 21,
    product: 22,
    videopro: 23,
    superdeals: 24,
    recentpurchase: 25,
    collections: 26,
    fast: 27,
    topbanner: 28,
    shoppingguide: 29,
    belowflashbanner: 30,
    timelinebanner: 31,
    activity: 32,
    friendsdeal: 33,
    sub_category: 34,
    navigation_home: 35,
    pro2: 41,
    fullpro: 42,
    smallbanner: 43,
    banner5_3: 44,
    banner2_1: 45,
    promore: 46
};
exports.PAGEIDS = {
    index: "10000000",
    default_listing: "20000006",
    search_listing: "20000000",
    flashdeal: "30000001",
    prime: "30000002",
    friendsdeal: "30000004",
    notfound: "99999999",
    products: "40000000",
    cart: "40000001",
    sellerStore: "40000003",
    my_index: "40000006",
    promotion_listing: "40000007",
    findSimilar: "40000008",
    ecoins: "40000009",
    orderList: "40000010",
    millionBenefit: "50000000"
};
exports.mobilePageIds = {
    search: exports.PAGEIDS.default_listing,
    category: exports.PAGEIDS.default_listing,
    surf: "30000005"
};
exports.webPageIds = {
    newcategory: exports.PAGEIDS.default_listing,
    category: exports.PAGEIDS.default_listing
};
var ComponentType;
(function (ComponentType) {
    ComponentType["Navigation"] = "02";
    ComponentType["Banner"] = "03";
    ComponentType["MagicBanner"] = "04";
    ComponentType["ProductWithTag"] = "05";
    ComponentType["Product"] = "06";
    ComponentType["CountBanner"] = "07";
    ComponentType["FlashProductWithTag"] = "08";
    ComponentType["FlashProduct"] = "09";
    ComponentType["Event"] = "10";
    ComponentType["MagicBannerTwo"] = "11";
    ComponentType["Voucher"] = "12";
    ComponentType["Coupon"] = "13";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var Site;
(function (Site) {
    Site[Site["EZBUY"] = 1] = "EZBUY";
    Site[Site["MULT_EZBUY"] = 2] = "MULT_EZBUY";
    Site[Site["LITB"] = 3] = "LITB";
})(Site = exports.Site || (exports.Site = {}));
exports.EZSPM = {
    PLATFORM: exports.PLATFORM,
    CHANNELS: exports.CHANNELS,
    PAGEIDS: exports.PAGEIDS
};
